import {ApiFindOptions, useApiFind} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import { PATH as ROSTER_PATH } from '../const';
import {StubbornScreen} from "../../../../../application/business/StubbornAsset";

export const useRosterScreenContextFind = (options: ApiFindOptions = {}) => useApiFind<StubbornScreen>(`${ROSTER_PATH}${PATH}`, options);
